var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-center" },
    [
      _c(
        "v-menu",
        {
          attrs: {
            "offset-y": "",
            "offset-overflow": "",
            "close-on-content-click": false,
          },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        { staticClass: "clickable-icon text-no-wrap" },
                        "div",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "", large: "" } },
                        [
                          !_vm.serverMode
                            ? [
                                _c(
                                  "v-avatar",
                                  { attrs: { size: "32px", item: "" } },
                                  [
                                    _c("v-img", {
                                      attrs: {
                                        src: require("@/assets/logo-xs-orange-white.svg"),
                                        alt: "Heimdall Logo",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : [
                                _c(
                                  "v-avatar",
                                  {
                                    attrs: {
                                      size: "32px",
                                      color: "primary",
                                      item: "",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.userInitials)),
                                    ]),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                      _c("v-icon", { attrs: { id: "dropdown", small: "" } }, [
                        _vm._v("mdi-menu-down"),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "v-list",
            { staticClass: "pt-0 pb-0", attrs: { id: "dropdownList" } },
            [
              _vm.serverMode
                ? _c(
                    "div",
                    [
                      _vm.isAdmin
                        ? _c(
                            "div",
                            [
                              _c(
                                "IconLinkItem",
                                {
                                  key: "admin",
                                  attrs: {
                                    text: "Admin Panel",
                                    icon: "mdi-shield-account",
                                    link: "/admin",
                                  },
                                },
                                [_vm._v(" Admin Panel ")]
                              ),
                              _c("v-divider"),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "IconLinkItem",
                        {
                          key: "groups",
                          attrs: {
                            id: "groups-link",
                            text: "Groups",
                            icon: "mdi-account-group",
                            link: "/manage-groups",
                          },
                        },
                        [_vm._v(" Groups ")]
                      ),
                      _c("v-divider"),
                      _c("UserModal", {
                        attrs: { id: "userModal", user: _vm.userInfo },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "clickable",
                              fn: function ({ on }) {
                                return [
                                  _c(
                                    "IconLinkItem",
                                    _vm._g(
                                      {
                                        key: "user",
                                        attrs: {
                                          id: "user-link",
                                          text: "User Info",
                                          icon: "mdi-account",
                                        },
                                      },
                                      on
                                    ),
                                    [_vm._v(" My Profile ")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2002543672
                        ),
                      }),
                      _c("LogoutButton"),
                      _c("v-divider"),
                    ],
                    1
                  )
                : _vm._e(),
              _c("HelpModal", {
                scopedSlots: _vm._u([
                  {
                    key: "clickable",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "IconLinkItem",
                          _vm._g(
                            {
                              key: "help",
                              attrs: {
                                id: "helpModal",
                                text: "Help",
                                icon: "mdi-help-circle",
                              },
                            },
                            on
                          ),
                          [_vm._v(" Help ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("AboutModal", {
                scopedSlots: _vm._u([
                  {
                    key: "clickable",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "IconLinkItem",
                          _vm._g(
                            {
                              key: "about",
                              attrs: {
                                id: "aboutModal",
                                text: "About",
                                icon: "mdi-information",
                              },
                            },
                            on
                          ),
                          [_vm._v(" About ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }